export default function insertNames (names) {
    const allUsers = {};
    try {
        if (typeof names === 'object' && names !== null) {
            Object.entries(names).map(([key, value]) => {
                if (value['data'] && value['data'].length === 7) {
                    let data = value['data'];
                    // console.log(value, 'data');
                    allUsers[key] = {firstName: data[1], lastName: data[2], fnh: data[3], lnh: data[4], id: data[5], dob: data[6],
                    passport: {}, contact : {}, ff: {}, visa : {}, note : {}, credit: {}};
                    ['passport', 'contact', 'ff', 'visa', 'note', 'credit'].map((table) => {
                        data = value[table];
                        if (data && data.length) {
                            Object.keys(data).map((keyTableMap) => {
                                let dataTable = data[keyTableMap];
                                switch (table) {
                                    case 'passport':
                                        allUsers[key][table][dataTable[0]] = {land: dataTable[2], number: dataTable[3], firstName: dataTable[4], 
                                            lastName: dataTable[5], issue: dataTable[6], expiry: dataTable[7]}
                                        break;
                                    case 'contact':
                                        allUsers[key][table][dataTable[0]] = {type: dataTable[2], data: dataTable[3]};
                                        break;
                                    case 'ff':
                                        allUsers[key][table][dataTable[0]] = {compny: dataTable[2], code: dataTable[3], number: dataTable[4], remark: dataTable[5]};
                                        break;
                                    case 'visa':
                                        allUsers[key][table][dataTable[0]] = {land: dataTable[2], number: dataTable[3], issue: dataTable[4], expiry: dataTable[5]};
                                        break;
                                    case 'note':
                                        allUsers[key][table][dataTable[0]] = {dataNote: dataTable[2]};
                                        break;
                                    case 'credit':
                                        allUsers[key][table][dataTable[0]] = 
                                        {number: dataTable[2].padStart(12, "*"), date: dataTable[4], cvv: dataTable[3], id: dataTable[5], name: dataTable[6]};
                                        break;
                                    default:
                                        break;
                                }
                            })
                        }
                    })
                }
            })
        }
    } catch (error) {
        allUsers = {}
    } finally {
        return allUsers;
    }
}